import Colors from '../utils/colors';
import BackArrow from '../icons/BackArrow';
import IconButton from '../IconButton';

const BackButton = ({ size = 'base', ...rest }) => (
  <IconButton {...rest}>
    <BackArrow color={Colors.dark} size={size} />
  </IconButton>
);

BackButton.propTypes = {
  ...IconButton.propTypes
};

export default BackButton;
